import { render } from "./UrgeUpdateModal.vue?vue&type=template&id=57c8c6d5&scoped=true"
import script from "./UrgeUpdateModal.vue?vue&type=script&lang=js"
export * from "./UrgeUpdateModal.vue?vue&type=script&lang=js"

import "./UrgeUpdateModal.vue?vue&type=style&index=0&id=57c8c6d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c8c6d5"]])

export default __exports__